import { array, record } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { DaysParameters } from '@mews-commander/data-access';
import { WeekDay } from '@mews/enums';

export const daysArrayToDaysParameters = (daysArray: string[]): DaysParameters =>
    pipe(
        Object.values(WeekDay),
        array.reduce({}, (daysParameters, weekDay) =>
            pipe(daysParameters, record.upsertAt(weekDay.toLowerCase(), daysArray.includes(weekDay)))
        )
    ) as DaysParameters;
